module.exports = __webpack_public_path__ + "img/full2-min.40949b71.png";